var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.address)?_c('div',[_vm._v("\n  "+_vm._s(_vm.formattedAddress())+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }